var React = require('react');

function SmileyHappyLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 20.21a1 1 0 01-.85-.47 3.73 3.73 0 00-5.12-1.18 3.688 3.688 0 00-1.18 1.18 1.001 1.001 0 01-1.7-1.06 5.75 5.75 0 016.13-2.54 5.73 5.73 0 013.57 2.54 1 1 0 01-.85 1.53zm10 0a.93.93 0 01-.53-.15 1 1 0 01-.32-1.38 5.73 5.73 0 019.7 0 1.004 1.004 0 11-1.7 1.07 3.71 3.71 0 00-6.3 0 1.001 1.001 0 01-.85.46zM24.02 40a14 14 0 01-12.95-8.62 1.003 1.003 0 011.85-.77 12 12 0 0022.15 0 1.003 1.003 0 011.85.77A14 14 0 0124.02 40z","key":0}),React.createElement("path",{"d":"M24 48A24 24 0 1124-.001 24 24 0 0124 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":1})]);
}

SmileyHappyLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SmileyHappyLight;

SmileyHappyLight.default = SmileyHappyLight;
